import React from "react";

const decisions = {repair: "To be repaired", replace: "To be replaced"};

export default function CustomerInspection({inspection}) {
  const components = (inspection?.components || []).filter(component =>
    component.decision === "repair" || component.decision === "replace"
  );
  if (!components.length) return null;
  return <details className="customer-inspection" open>
    <summary>Inspection assessment</summary>
    <ul>
      {components.map((component, index) => <li key={index}>
        <div><strong>{component.name}</strong><span>{decisions[component.decision] || component.decision}</span></div>
        <div className="customer-inspection-amount">
          <strong>{component.amount == null ? "Charge unavailable" : new Intl.NumberFormat("en-IN", {style: "currency", currency: "INR"}).format(Number(component.amount))}</strong>
          {component.covered ? <span>Warranty covered</span> : component.waived ? <span>Fee waived</span> : null}
        </div>
      </li>)}
    </ul>
  </details>;
}
